<!-- ACT Row -->
<div
  class="flight-row act-row"
  [class.e-cxld]="enhanced && leg.isCancelled.text === 'True'"
>
  <span
    [class.e-skd]="enhanced && leg.isCancelled.text === 'False'"
    class="status"
    >ACT
  </span>
  <!-- Day -->
  @if (leg.isCancelled.text === "True") {
    <span>{{ " ".padEnd(3, " ") }}</span>
  } @else {
    <span [class.e-day]="enhanced">{{
      hssBuilderService.getDay(leg, "ACT").padEnd(3, " ")
    }}</span>
  }
  <!-- Equip -->
  @if (leg.isDhOrSurface.text === "True") {
    <span
      [class.e-eq]="enhanced && leg.isCancelled.text === 'False'"
      [class]="hssBuilderService.getChangedClass(leg.actualEquipCode.didChange)"
      >{{ "XX".padEnd(3, " ") }}</span
    >
  } @else {
    <span
      [class.e-eq]="enhanced && leg.isCancelled.text === 'False'"
      [class]="hssBuilderService.getChangedClass(leg.actualEquipCode.didChange)"
      >{{ hssBuilderService.getSkdEquipCode(leg).padEnd(3, " ") }}</span
    >
  }
  <!-- Flt Num -->
  <span
    [class.e-flt-num]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.fltNum.didChange)"
    >{{ hssBuilderService.toInt(leg.fltNum.text).padStart(4, " ") }}
  </span>
  <!-- Dep Sta -->
  <span
    [class.e-dep-sta]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.depStation.didChange)"
    >{{ leg.depStation.text.padEnd(4, " ") }}</span
  >
  <!-- Dep Time -->
  @if (leg.isCancelled.text === "True") {
    <span>{{ " ".padEnd(5, " ") }}</span>
  } @else {
    <span
      [class.e-dep-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(leg.depTimeActualLocal.didChange)
      "
      >{{ leg.depTimeActualLocal.text | hssTime
      }}{{ leg.depTimeIsEstimated.text === "True" ? "*" : " " }}</span
    >
  }
  <!-- Meal -->
  <span
    [class.e-meal]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.meal.didChange)"
    >{{ leg.meal.text.padEnd(2, " ") }}</span
  >
  <!-- Arr Sta -->
  <span
    [class.e-arr-sta]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.arrStation.didChange)"
    >{{ leg.arrStation.text.padEnd(4, " ") }}</span
  >
  <!-- Arr Time -->
  @if (leg.isCancelled.text === "True") {
    <span>{{ " ".padEnd(5, " ") }}</span>
  } @else {
    <span
      [class.e-arr-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.arrTimeActualLocal.didChange,
          index
        )
      "
      >{{ leg.arrTimeActualLocal.text | hssTime
      }}{{ leg.arrTimeIsEstimated.text === "True" ? "*" : " " }}</span
    >
  }
  <!-- Add Code -->
  <span
    [class.e-ac]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.addCode.didChange)"
    >{{ leg.addCode.text.padEnd(2, " ") }}</span
  >
  <!-- Flt Time -->
  @if (leg.isCancelled.text === "True") {
    <span [class.e-flt-time]="enhanced" [class.e-cxld]="enhanced">{{
      " 0.00  "
    }}</span>
  } @else {
    <span
      [class.e-flt-time]="
        enhanced &&
        leg.isCancelled.text === 'False' &&
        leg.isDhOrSurface.text === 'False'
      "
      [class.e-dh]="
        enhanced &&
        leg.isCancelled.text === 'False' &&
        leg.isDhOrSurface.text === 'True'
      "
      [class]="
        hssBuilderService.getChangedClass(
          leg.depTimeActual.didChange || leg.arrTimeActual.didChange,
          index
        )
      "
      >{{ hssBuilderService.getFlightTimeActual(leg).padStart(7, " ") }}</span
    >
  }
  <!-- Gtr Time -->
  @if (leg.isCancelled.text === "True") {
    <span
      [class.e-cxld]="enhanced"
      [class]="
        hssBuilderService.getChangedClass(leg.isCancelled.didChange, index)
      "
    >
      {{ "  CXLD" }}
    </span>
  } @else {
    <span
      [class.e-gtr-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(leg.greaterTime.didChange, index)
      "
      >{{ leg.greaterTime.text.padStart(5, " ") }}</span
    >
  }
  <!-- Gnd Time -->
  <span
    [class.e-gnd-time]="enhanced && leg.isCancelled.text === 'False'"
    [class]="
      hssBuilderService.getChangedClass(leg.groundTimeActual.didChange, index)
    "
    >{{ (leg.groundTimeActual.text | hssDuration).padStart(5, " ") }}</span
  >
  <!-- Remarks -->
  {{ setLegRemarks(leg) }}
  @if (legRemarks.length > 0 && leg.isCancelled.text === "False") {
    @if (legRemarks[0].property === "DelayMinutesRamp") {
      <span
        [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
        [class]="
          hssBuilderService.getChangedClass(
            leg.rampDelayMinutes.didChange,
            index
          )
        "
        >RCD {{ leg.rampDelayMinutes.text }}
      </span>
    }
    @if (legRemarks[0].property === "DelayMinutesATC") {
      <span
        [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
        [class]="
          hssBuilderService.getChangedClass(
            leg.atcDelayMinutes.didChange,
            index
          )
        "
        >ATC {{ leg.atcDelayMinutes.text }}
      </span>
    }
    @if (legRemarks[0].property === "DelayMinutesDeIcing") {
      <span
        [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
        [class]="
          hssBuilderService.getChangedClass(
            leg.deicingDelayMinutes.didChange,
            index
          )
        "
        >DEI {{ leg.deicingDelayMinutes.text }}
      </span>
    }
    @if (legRemarks[0].property === "DiversionTime") {
      <span
        [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
        [class]="
          hssBuilderService.getChangedClass(leg.diversionTime.didChange, index)
        "
        >DIV {{ leg.diversionTime.text }}
      </span>
    }
    @if (legRemarks[0].property === "Diversion") {
      <span
        [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
        [class]="
          hssBuilderService.getChangedClass(leg.isDiversion.didChange, index)
        "
        >{{ "DVTD".padStart(6, " ") }}
      </span>
    }
    @if (legRemarks[0].property === "GrndInterrupt") {
      <span
        [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
        [class]="
          hssBuilderService.getChangedClass(
            leg.isGroundInterrupt.didChange,
            index
          )
        "
        >{{ "RTD".padStart(5, " ") }}
      </span>
    }
    @if (legRemarks[0].property === "Stub") {
      <span
        [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
        [class]="hssBuilderService.getChangedClass(leg.isStub.didChange, index)"
        >{{ "STUB".padStart(6, " ") }}</span
      >
    }
    @if (legRemarks[0].property === "AirInterrupt") {
      <span
        [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
        [class]="
          hssBuilderService.getChangedClass(leg.isAirInterrupt.didChange, index)
        "
        >{{ "AIR".padStart(5, " ") }}
      </span>
    }
  }
  @for (remark of legRemarks; track remark.property; let i = $index) {
    @if (i > 0) {
      <div>
        @if (legRemarks[i].property === "DelayMinutesRamp") {
          <span
            [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
            [class]="
              hssBuilderService.getChangedClass(
                leg.rampDelayMinutes.didChange,
                index
              )
            "
            >RCD {{ leg.rampDelayMinutes.text.padStart(59, " ") }}
          </span>
        }
        @if (legRemarks[i].property === "DelayMinutesATC") {
          <span
            [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
            [class]="
              hssBuilderService.getChangedClass(
                leg.atcDelayMinutes.didChange,
                index
              )
            "
            >ATC {{ leg.atcDelayMinutes.text.padStart(59, " ") }}
          </span>
        }
        @if (legRemarks[i].property === "DelayMinutesDeIcing") {
          <span
            [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
            [class]="
              hssBuilderService.getChangedClass(
                leg.deicingDelayMinutes.didChange,
                index
              )
            "
            >DEI
            {{ leg.deicingDelayMinutes.text.padStart(59, " ") }}
          </span>
        }
        @if (legRemarks[i].property === "DiversionTime") {
          <span
            [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
            [class]="
              hssBuilderService.getChangedClass(
                leg.diversionTime.didChange,
                index
              )
            "
            >DIV {{ leg.diversionTime.text.padStart(59, " ") }}
          </span>
        }
        @if (legRemarks[i].property === "Diversion") {
          <span
            [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
            [class]="
              hssBuilderService.getChangedClass(
                leg.isDiversion.didChange,
                index
              )
            "
            >{{ "DVTD".padStart(62, " ") }}</span
          >
        }
        @if (legRemarks[i].property === "GrndInterrupt") {
          <span
            [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
            [class]="
              hssBuilderService.getChangedClass(
                leg.isGroundInterrupt.didChange,
                index
              )
            "
            >{{ "RTD".padStart(61, " ") }}</span
          >
        }
        @if (legRemarks[i].property === "Stub") {
          <span
            [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
            [class]="
              hssBuilderService.getChangedClass(leg.isStub.didChange, index)
            "
            >{{ "STUB".padStart(62, " ") }}</span
          >
        }
        @if (legRemarks[i].property === "AirInterrupt") {
          <span
            [class.e-act]="enhanced && leg.isCancelled.text === 'False'"
            [class]="
              hssBuilderService.getChangedClass(
                leg.isAirInterrupt.didChange,
                index
              )
            "
            >{{ "AIR".padStart(61, " ") }}</span
          >
        }
      </div>
    }
  }
</div>
